import { GetTeamRequest } from "@/Stub/V1";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import { TeamsApiClient } from "@/Service/Api/V1/ApiClients/TeamsApiClient";

export type useGetTeamParams = {
    requestParams: GetTeamRequest
    enabled?: boolean
    savePreviousData?: boolean
};

export const useGetTeam = ({ requestParams, enabled, savePreviousData }: useGetTeamParams) => useQuery({
    ...QueryKeys.teams.detail(requestParams),
    queryFn: async () => await TeamsApiClient.getTeam(requestParams),
    enabled,
    gcTime: 0,
    placeholderData: savePreviousData ? keepPreviousData : undefined
});